import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ICommentItem {
  author: string;
  dateTime?: Date;
  content: string;
}

@Component({
  selector: 'em-comment-list',
  templateUrl: './comment-list.component.html',
  standalone: false,
})
export class CommentListComponent {
  @Input() public pageIndex = 1;
  @Input() public pageSize = 1;
  @Input() public comments: ICommentItem[] = [];
  @Input() public loading = false;
  @Input() public totalComments = 0;

  @Output() public readonly changePage = new EventEmitter<number>();
  @Output() public readonly changePageSize = new EventEmitter<number>();

  public pageChanged(pageIndex: number) {
    this.changePage.emit(pageIndex);
  }

  public pageSizeChanged(pageSize: number) {
    this.changePageSize.emit(pageSize);
  }
}
